import { APP_ROUTES } from 'constants/routes';

import { SEARCH_DOMAIN, type SearchDomain } from './constants';

/** Query-string names of the results page (Vue parity: `/search?search=&active=`). */
export const SEARCH_QUERY_PARAM = 'search';
export const SEARCH_ACTIVE_PARAM = 'active';

/**
 * The results page for `query`, landing on `domain`'s tab. The one place
 * this URL is assembled — the header's Enter key and footer button route
 * through it, and the page reads the same two parameter names back.
 */
export function searchResultsRoute(
  query: string,
  domain: SearchDomain = SEARCH_DOMAIN.ORDERS,
): string {
  const q = encodeURIComponent(query);
  return `${APP_ROUTES.search}?${SEARCH_QUERY_PARAM}=${q}&${SEARCH_ACTIVE_PARAM}=${domain}`;
}
